export default __webpack_public_path__ + "static/media/gd.ffbd15bc.png";